import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';
import { KimMode, PlanStage } from '@/types';

interface ProcessPlanProps {
  threadId: string;
  matterId: string;
  subsetId: string;
  question: string;
  mode: KimMode | null;
  plan: PlanStage[];
}

export const useProcessPlan = () => {
  const { getFetchConfig } = useGetFetchConfig();

  const createMessage = async ({ threadId, question, matterId, subsetId, mode, plan }: ProcessPlanProps) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: {
        question,
        mode,
        parameters: plan,
        threadId,
      },
    });

    const response = await fetch(
      `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/thread/plan`,
      fetchConfig,
    );
    if (!response.ok) {
      throw new Error('Error creating message');
    }
    return response.json();
  };

  return useMutation(async ({ threadId, question, matterId, subsetId, mode, plan }: ProcessPlanProps) => {
    return createMessage({ threadId, question, matterId, subsetId, mode, plan });
  });
};
